import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutPackageTypeXref extends Layout {
    buttonExpand: Button;
    horizontalspacerForTrailerType: HorizontalSpacer;
    labelCrossRef: Label;
    panelButtons: Panel;
    panelCollapsible: Panel;
    panelHeader: Panel;
    panelPackageTypeXref: Panel;
    sourceEdiCrossRefPackageTypeCode: DataSource;
    tableCrossRef: Table;
}
